import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseReplenishmentRequestView } from "src/components/views/erp/warehouse/replenishment/WarehouseReplenishmentRequestView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/dataCollection")({
	staticData: { title: i18n.t("data_collection"), legacyViewKey: "warehouseReplenishmentRequestPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehouseReplenishmentRequestView />;
}
